<form [formGroup]="formGroup">
  <div formArrayName="education">
    <div class="card-data" *ngFor="let edu of education.controls; let i = index" [formGroupName]="i">
      <div class="d-flex">
        <h4>{{ "Education" | translate }} </h4>
        <i *ngIf="education.length > 1" (click)="removeEducation(i)" class="col-auto bi bi-trash3 delete-icon"></i>
      </div>

      <div class="date-container">
        <div class="date">
          <label>{{ "Level of Education (Degree)" | translate }} <span style="color: red;">*</span></label>
          <select formControlName="degree" class="form-select" [dir]="userLang == 'ar' ? 'rtl' : 'ltr'">
            <option value="">{{ 'SelectEducationLevel' | translate }}</option>
            <option *ngFor="let degree of degrees" [value]="degree.value">
              {{ degree.label | translate }}
            </option>
          </select>
        </div>

        <div class="date">
          <label>{{ "Major" | translate }} <span style="color: red;">*</span></label>
          <input type="text" formControlName="major" placeholder="{{ 'Enter your major' | translate }}" />
          <div class="error" *ngIf="edu.get('major')?.touched && edu.get('major')?.invalid">
            <span *ngIf="edu.get('major')?.errors?.['required']">
              {{ "Major is required" | translate }}
            </span>
            <span *ngIf="edu.get('major')?.errors?.['minlength']">
              {{ "Major must be at least 2 characters" | translate }}
            </span>
          </div>
        </div>
      </div>

      <label>{{ "University Name (faculty)" | translate }} <span style="color: red;">*</span></label>
      <input type="text" formControlName="university" placeholder="{{ 'Enter your faculty' | translate }}" />
      <div class="error" *ngIf="edu.get('university')?.touched && edu.get('university')?.invalid">
        <span *ngIf="edu.get('university')?.errors?.['required']">
          {{ "University is required" | translate }}
        </span>
        <span *ngIf="edu.get('university')?.errors?.['minlength']">
          {{ "University must be at least 2 characters" | translate }}
        </span>
      </div>

      <div class="date-container">
        <div class="date">
          <label>{{ "End Date" | translate }}<span style="color: red;">*</span></label>
          <input type="date" formControlName="endDate" />
          <div class="error" *ngIf="edu.get('endDate')?.touched && edu.get('endDate')?.invalid">
            <span> {{ "End Date is required" | translate }}</span>
          </div>
        </div>

        <div class="date">
          <label>{{ "Graduate Degree" | translate }}</label>
          <input type="text" formControlName="grade" placeholder="{{ 'Select graduate degree' | translate }} / GPA" />
        </div>
      </div>

      <label>{{ "Details" | translate }}</label>
      <textarea formControlName="details" placeholder="{{ 'Additional details (optional)' | translate }}"></textarea>
    </div>

    <div class="card-data add-new" (click)="addEducation()">
      <h6>{{ "Add New Education" | translate }}</h6>
      <i class="bi bi-plus-circle"></i>
    </div>

    <div class="next-container px-4">
      <button class="border-button m-3" (click)="onPrevious()">
        {{ "Back" | translate }}
      </button>
      <button class="gradient-button m-3" (click)="onNext()">
        {{ "Next" | translate }}
      </button>
    </div>
  </div>
</form>